import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import useSWR from 'swr';
import fetcherGraphQL from 'commons/fetcherGraphQL';
const useSWRQuery = (query, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== query) {
    t0 = {
      query
    };
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryObject = t0;
  let t1;
  if ($[2] !== queryObject) {
    t1 = async () => fetcherGraphQL(queryObject);
    $[2] = queryObject;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fetchQuery = t1;
  const {
    data,
    error,
    isLoading
  } = useSWR(query || null, fetchQuery, options);
  const t2 = isLoading && !data;
  let t3;
  if ($[4] !== data || $[5] !== error || $[6] !== t2) {
    t3 = {
      data,
      error,
      isLoading: t2
    };
    $[4] = data;
    $[5] = error;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default useSWRQuery;